import { Injectable } from '@angular/core';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';
import { TemplateRequestInterface } from '../../interfaces/template-request.interface';
import { TemplateDialogDataInterface } from '../../interfaces/template-dialog-data.interface';
import { FormGroup } from '@angular/forms';
import { DropdownConfigInterface } from '@interfaces/dropdown-config.interface';
import { SaveTemplateRequestInterface } from '../../interfaces/save-template-request.interface';
import { DropOffTypeEnum } from '@modules/service-request-template/enums/drop-off-type.enum';

@Injectable()
export class TemplateSharedService {
  singlePickUp: BaseDropdownInterface = {
    id: '1',
    name: 'Single Pick up / Single Drop Off',
  };
  singleDropOff: BaseDropdownInterface = {
    id: '2',
    name: 'Multiple Pick Up / Single Drop Off',
  };
  multipleDropOff: BaseDropdownInterface = {
    id: '3',
    name: 'Single Pick Up / Multiple Drop Off',
  };

  templateTypes(legCount: number): BaseDropdownInterface[] {
    const result: BaseDropdownInterface[] = [];

    if (legCount <= 2) {
      result.push(this.singlePickUp);
    }

    if (legCount > 1) {
      result.push(this.singleDropOff);
      result.push(this.multipleDropOff);
    }

    return result;
  }

  defaultTemplateType(legCount: number): BaseDropdownInterface {
    if (legCount <= 2) {
      return this.singlePickUp;
    }

    return this.singleDropOff;
  }

  defaultDropOffType(legCount: number): DropOffTypeEnum {
    return legCount > 1 ? DropOffTypeEnum.WAIT_AND_RETURN : DropOffTypeEnum.DROP_ONLY;
  }

  generateTemplateRequestBody(dialogData: TemplateDialogDataInterface, form: FormGroup): TemplateRequestInterface {
    const result: TemplateRequestInterface = {
      serviceRequestId: dialogData.serviceRequestId,
      dropOffType: form.get('dropOffType').value,
      templateType: Number(form.get('templateType').value.id),
      legIds: [...dialogData.selectedLegs.values()].map((item) => item.legId),
    };

    if (form.get('leadPassenger')?.value) {
      result.leadPassengerId = form.get('leadPassenger').value.id;
    }

    if (form.get('returnLocation')?.value) {
      result.returnLocationId = form.get('returnLocation').value.id;
    }

    return result;
  }

  generateSaveTemplateRequestBody(
    dialogData: TemplateDialogDataInterface,
    form: FormGroup,
    templateId: string,
  ): SaveTemplateRequestInterface {
    return {
      ...this.generateTemplateRequestBody(dialogData, form),
      templateId,
      templateText: form.get('textTemplate').value,
    };
  }

  generateDropdownConfig(displayKey: string, placeholder: string, search = true): DropdownConfigInterface {
    return {
      displayKey,
      search,
      placeholder,
      height: '400px',
    };
  }
}
